import axios from 'axios';
import axiosRetry from 'axios-retry';
import { env } from '@/utils/configs/env';

const axiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosRetry(axiosInstance, {
  retries: 1,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: error => {
    return error.response?.status === 401;
  },
});

export { axiosInstance };
